import * as React from 'react';
import { FilterRow } from '@/components/custom/filter';
import { Label } from '@/components/ui/label';
import { SelectNative } from '@/components/ui/select-native';

const FilterSelectNative = React.forwardRef(
  ({ value, onChange, label, options, optionBlank = 'blank', blankLabel = 'Selecione para filtrar...', disabled, icon, hasError, errorText = 'Campo inválido', blankDisabled = false, wrapperClassName, ...props }, ref) => {
    const id = React.useId();

    return (
      <FilterRow
        ref={ref}
        className={wrapperClassName}
      >
        {label && (
          <Label
            htmlFor={id}
            disabled={disabled}
          >
            {label}
          </Label>
        )}
        <SelectNative
          id={id}
          aria-invalid={Boolean(hasError) || Boolean(props['aria-invalid'])}
          name={label}
          value={value || ''}
          onChange={onChange}
          disabled={disabled}
          icon={icon}
          {...props}
        >
          {!blankDisabled && <option value={optionBlank}>{blankLabel}</option>}
          {Array.isArray(options) &&
            options?.map(option => (
              <option
                key={option.id}
                value={option.id}
              >
                {option.name ?? option.title ?? option.body}
              </option>
            ))}
        </SelectNative>

        {hasError && (
          <p
            className="mb-0 text-xs text-danger"
            role="alert"
            aria-live="polite"
          >
            {errorText}
          </p>
        )}
      </FilterRow>
    );
  }
);
FilterSelectNative.displayName = 'FilterSelectNative';

export { FilterSelectNative };
